import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette';
import { IMAGE_DIMENSIONS } from '@/constants/ActivitiesConfig.js';

const CommentImageThumbnail = ({ blobUrl, onClick }) => {
    if (!blobUrl) {
        return (
            <Box
                sx={{
                    width: IMAGE_DIMENSIONS.THUMBNAIL_SIZE,
                    height: IMAGE_DIMENSIONS.THUMBNAIL_SIZE,
                    borderRadius: '8px',
                    backgroundColor: Palette.gray.gray100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <CircularProgress size={20} />
            </Box>
        );
    }

    return (
        <Box
            component='img'
            src={blobUrl}
            alt=''
            onClick={onClick}
            sx={{
                width: IMAGE_DIMENSIONS.THUMBNAIL_SIZE,
                height: IMAGE_DIMENSIONS.THUMBNAIL_SIZE,
                borderRadius: '8px',
                objectFit: 'cover',
                backgroundColor: Palette.gray.gray100,
                cursor: 'pointer',
                '&:hover': { opacity: 0.9 },
            }}
        />
    );
};

CommentImageThumbnail.propTypes = {
    blobUrl: PropTypes.string,
    onClick: PropTypes.func,
};

export default CommentImageThumbnail;
